import { fuelExpenses } from './SpecificTables/fuelExpenses'
import { parking } from './SpecificTables/parking'
import { tollPassings } from './SpecificTables/tollPassings'
import { workshop } from './SpecificTables/workshop'

export function findTable(filter) {
  switch (filter) {
    case 'fuel':
      return fuelExpenses()
    case 'toll':
      return tollPassings()
    case 'workshop':
      return workshop()
    case 'park':
      return parking()
    default:
      return []
  }
}
